export const examLink = (examid) => `/exams/exam/${examid}`;
